import moment from "moment";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const Dashboard = ({ AnotherComponent }) => {
  const adminToken = JSON.parse(localStorage.getItem("EXAMNP:admin-token"));
  const adminProfile = JSON.parse(localStorage.getItem("EXAMNP:admin-profile"));
  const navigate = useNavigate();

  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.removeItem("EXAMNP:admin-token");
    localStorage.removeItem("EXAMNP:admin-profile");
    toast.success("You have been logged out successfully.");
    navigate("/admin/login");
  };
  return (
    <>
      <div className="flex bg-gray-600">
        <div className="md:flex w-2/5 md:w-1/6 h-screen bg-gray-600 border-r hidden">
          <div className="mx-auto px-5 py-4">
            <h1 className="text-2xl font-bold mb-5 cursor-pointer text-[#EC5252] duration-150">
              Online-exam.np
            </h1>
            <hr />
            <ul className="py-5">
              {adminToken === null ? (
                <Link to="/admin/dashboard">
                  <li className="flex space-x-2 mt-6 cursor-pointer text-gray-200 hover:text-[#EC5252] duration-150">
                    <i className="fa-solid fa-house-user"></i>
                    <span className="font-semibold">Dashboard</span>
                  </li>
                </Link>
              ) : (
                <div>
                  <Link to="/admin/dashboard">
                    <li className="flex space-x-2 mt-6 cursor-pointer text-gray-200 hover:text-[#EC5252] duration-150">
                      <i className="fa-solid fa-house-user"></i>
                      <span className="font-semibold">Dashboard</span>
                    </li>
                  </Link>
                  <Link to="/admin/exams">
                    <li className="flex space-x-2 mt-6 cursor-pointer text-gray-200 hover:text-[#EC5252] duration-150">
                      <i className="fa-solid fa-book-open-reader"></i>
                      <span className="font-semibold">Exams</span>
                    </li>
                  </Link>
                  <Link to="/admin/answers">
                    <li className="flex space-x-2 mt-6 cursor-pointer text-gray-200 hover:text-[#EC5252] duration-150">
                      <i className="fa-solid fa-pen-nib"></i>
                      <span className="font-semibold">Answers</span>
                    </li>
                  </Link>
                  <Link to="/admin/results">
                    <li className="flex space-x-2 mt-6 cursor-pointer text-gray-200 hover:text-[#EC5252] duration-150">
                      <i className="fa-solid fa-square-poll-horizontal"></i>
                      <span className="font-semibold">Results</span>
                    </li>
                  </Link>
                  <Link to="/admin/students">
                    <li className="flex space-x-2 mt-6 cursor-pointer text-gray-200 hover:text-[#EC5252] duration-150">
                      <i className="fa-solid fa-graduation-cap"></i>
                      <span className="font-semibold">Students</span>
                    </li>
                  </Link>
                </div>
              )}
            </ul>
          </div>
        </div>
        <main className="min-h-screen w-full bg-white border-l">
          <nav className="flex items-center justify-between px-10 bg-gray-600 rounded-sm py-3 border-b">
            <div className="flex items-center bg-gray-600 px-4 py-2 rounded-lg space-x-3 w-96"></div>
            {adminToken === null ? (
              <div className="flex items-center space-x-4">
                <button
                  className=" bg-indigo-600 hover:bg-indigo-500 text-gray-200 hover:text-white
                          px-3 py-2 rounded-md text-sm font-medium ml-5 hover:cursor-pointer"
                  onClick={() => {
                    navigate("/admin/login");
                  }}
                >
                  <i className="fa-solid fa-right-to-bracket mr-1"></i> Login
                </button>
              </div>
            ) : (
              <div className="flex items-center space-x-4">
                <p className="mr-2 text-xl text-gray-300 font-semibold">
                  Admin: {adminProfile.fullName}
                </p>
                <button
                  className="bg-[#EC5252] text-gray-200 hover:bg-red-600 hover:text-white
                          px-3 py-2 rounded-md text-sm font-medium ml-5 hover:cursor-pointer"
                  onClick={(e) => {
                    handleLogout(e);
                  }}
                >
                  <i className="fa-solid mr-1 fa-power-off rotate-180"></i>
                  Logout
                </button>
              </div>
            )}
          </nav>
          <div className="container">{AnotherComponent}</div>

          <span className="block text-sm text-gray-500 sm:text-center dark:text-gray-400">
            Copyright &copy; {moment(Date.now()).year()} | Online Exam Portal
            Nepal
          </span>
        </main>
      </div>
    </>
  );
};

export default Dashboard;
